import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Category = () => {
  const [catList, setCatList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/categories`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await res.json();
      // console.log("data", data);
      setCatList(data.responseObject);
      
      // Ensure loader shows for at least 0.4 seconds
      setTimeout(() => {
        setIsLoading(false);
      }, 400);
    } catch (error) {
      // console.log("fetch cat error", error.response);
      setIsLoading(false);
    }
  };

  const handleCategorySelect = (categoryId) => {
    navigate(`/view-all?category=${categoryId}`);
  };

  if (isLoading) {
    return (
      <div className="loader-main" style={{ background: "white" }}>
        <div className="loaderaa"></div>
      </div>
    );
  }

  return (
    <>
      <section
        className="hero-section"
        style={{
          background: "#3c3260",
          padding: "60px 0",
          marginTop: "100px",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-12 col-sm-12">
              <div style={{ color: "white", textAlign: "center" }}>
                <h1
                  style={{
                    fontSize: "3.5rem",
                    marginBottom: "20px",
                    color: "white",
                  }}
                >
                  Our Categories
                </h1>
                <p
                  style={{
                    fontSize: "1.2rem",
                    marginBottom: "30px",
                    color: "white",
                  }}
                >
                  Explore our delightful collection of categories
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="category-sec" style={{ padding: "60px 0" }}>
        <div className="container">
          <div className="row justify-content-center g-4">
            {catList
              .filter((cat) => cat.isAvailable)
              .map((cat) => (
                <div
                  key={cat._id}
                  className="col-lg-3 col-md-4 col-sm-6 col-6 d-flex align-items-stretch"
                >
                  <div
                    onClick={() => handleCategorySelect(cat._id)}
                    className="w-100"
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      className="category-card h-100 d-flex flex-column justify-content-between text-center"
                      style={{
                        background: "white",
                        borderRadius: "15px",
                        padding: "25px 15px",
                        textAlign: "center",
                        transition: "all 0.3s ease",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                        transform: "translateY(0)",
                        ":hover": {
                          transform: "translateY(-5px)",
                          boxShadow: "0 5px 20px rgba(104, 40, 203, 0.15)",
                          background: "#f8f9fa",
                        },
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 5px 20px rgba(104, 40, 203, 0.15)";
                        e.currentTarget.style.background = "#f8f9fa";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 2px 10px rgba(0,0,0,0.1)";
                        e.currentTarget.style.background = "white";
                      }}
                    >
                      <img
                        src={`${cat.categoryImages}`}
                        alt={cat.categoryName}
                        style={{
                          width: "125px",
                          height: "125px",
                          objectFit: "cover",
                          margin: "0 auto 15px",
                          borderRadius: "10px",
                          border: "none",
                          padding: "2px",
                        }}
                      />
                      <h5
                        style={{
                          fontSize: "1.1rem",
                          color: "#333",
                          margin: 0,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {cat.categoryName}
                      </h5>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Category;
